import { MarketDataResponse, RegDataResponse, LocationDataResponse } from './dashboard-data.service';

/**
 * MOCK DASHBOARD DATA
 * ====================
 * 
 * Моковые данные для дашборда когда API недоступен или возвращает ошибки.
 * Автоматически используются как fallback в DashboardDataService.
 * 
 * Содержит два набора данных:
 * 1. PRIMARY (MOCK_*) - участок 04425, площадь 955 m², Jakarta Selatan
 * 2. ALTERNATIVE (MOCK_*_ALT) - участок 02394, площадь 32820 m², Jakarta Pusat
 * 
 * Выбор набора зависит от UUID:
 * - UUID содержит '0199aa4f' или равен '04425' → PRIMARY
 * - Иначе → ALTERNATIVE
 */

export const MOCK_MARKET_DATA: MarketDataResponse = {
  result: 'success',
  msg: null,
  data: {
    predict: [
      {
        predict_95: {
          lower_bound: 25422000000,
          upper_bound: 32212000000,
          lower_bound_per_sqm: 26600000,
          upper_bound_per_sqm: 33700000
        },
        predict_per_sqm: 31000000,
        predict_full: 29623859340,
        date: '2024-12-03',
        raw: ['comp1', 'comp2', 'comp3', 'comp4', 'comp5', 'comp6']
      }
    ],
    indexes: {
      vol: 8.5
    }
  }
};

export const MOCK_REG_DATA: RegDataResponse = {
  result: 'success',
  msg: null,
  data: {
    nib: '04425',
    size: '955',
    hakNum: 'HGB-12345',
    hakType: 'Hak Guna Bangunan',
    hackId: 1,
    centerCoord: [106.828197, -6.175336]
  }
};

export const MOCK_LOCATION_DATA: LocationDataResponse = {
  result: 'success',
  msg: null,
  data: {
    province: {
      id: 31,
      name: 'DKI Jakarta'
    },
    regency: {
      id: 3171,
      name: 'Jakarta Selatan'
    },
    kecamatan: {
      id: 317101,
      name: 'Kebayoran Baru'
    },
    village: {
      id: 31710101,
      name: 'Senayan'
    }
  }
};

/**
 * Alternative mock data set for variety
 */
export const MOCK_MARKET_DATA_ALT: MarketDataResponse = {
  result: 'success',
  msg: null,
  data: {
    predict: [
      {
        predict_95: {
          lower_bound: 564296800776,
          upper_bound: 1049982627201,
          lower_bound_per_sqm: 17193686,
          upper_bound_per_sqm: 31992160
        },
        predict_per_sqm: 24871852,
        predict_full: 816294182640,
        date: '2024-12-03',
        raw: ['c1', 'c2', 'c3', 'c4']
      }
    ],
    indexes: {
      vol: 12.3
    }
  }
};

export const MOCK_REG_DATA_ALT: RegDataResponse = {
  result: 'success',
  msg: null,
  data: {
    nib: '02394',
    size: '32820',
    hakNum: 'HGB-67890',
    hakType: 'Hak Guna Bangunan',
    hackId: 2,
    centerCoord: [106.825, -6.178]
  }
};

export const MOCK_LOCATION_DATA_ALT: LocationDataResponse = {
  result: 'success',
  msg: null,
  data: {
    province: {
      id: 31,
      name: 'DKI Jakarta'
    },
    regency: {
      id: 3175,
      name: 'Jakarta Pusat'
    },
    kecamatan: {
      id: 317502,
      name: 'Tanah Abang'
    },
    village: {
      id: 31750201,
      name: 'Kebon Melati'
    }
  }
};

